import * as React from "react";
const NewsDetail = (props) => (
  <svg
    width={22}
    height={18}
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 5.14286C8.8122 5.14286 7.03864 6.86976 7.03864 9C7.03864 11.1302 8.8122 12.8571 11 12.8571C13.1878 12.8571 14.9614 11.1302 14.9614 9C14.9614 6.86976 13.1878 5.14286 11 5.14286ZM8.62318 9C8.62318 7.72186 9.68732 6.68571 11 6.68571C12.3127 6.68571 13.3768 7.72186 13.3768 9C13.3768 10.2781 12.3127 11.3143 11 11.3143C9.68732 11.3143 8.62318 10.2781 8.62318 9Z"
      fill="#012272"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 0C8.73837 0 6.69347 1.08925 5.03338 2.41274C3.36422 3.74345 1.99938 5.37804 1.08225 6.62196L1.00661 6.72438C0.454487 7.47137 0 8.08627 0 9C0 9.91373 0.454487 10.5286 1.00661 11.2756L1.08225 11.378C1.99938 12.622 3.36422 14.2566 5.03338 15.5873C6.69347 16.9108 8.73837 18 11 18C13.2616 18 15.3065 16.9108 16.9666 15.5873C18.6358 14.2566 20.0006 12.622 20.9178 11.378L20.9934 11.2756C21.5455 10.5286 22 9.91373 22 9C22 8.08628 21.5455 7.47138 20.9934 6.72438L20.9178 6.62196C20.0006 5.37804 18.6358 3.74345 16.9666 2.41274C15.3065 1.08925 13.2616 0 11 0ZM2.36944 7.52172C3.24545 6.33359 4.51761 4.81797 6.03721 3.60649C7.56587 2.38779 9.26147 1.54286 11 1.54286C12.7385 1.54286 14.4341 2.38779 15.9628 3.60649C17.4824 4.81797 18.7546 6.33359 19.6306 7.52172C20.2897 8.41571 20.4155 8.63123 20.4155 9C20.4155 9.36877 20.2897 9.58429 19.6306 10.4783C18.7546 11.6664 17.4824 13.182 15.9628 14.3935C14.4341 15.6122 12.7385 16.4571 11 16.4571C9.26147 16.4571 7.56587 15.6122 6.03721 14.3935C4.51761 13.182 3.24545 11.6664 2.36944 10.4783C1.71031 9.58429 1.58454 9.36877 1.58454 9C1.58454 8.63123 1.71031 8.41571 2.36944 7.52172Z"
      fill="#012272"
    />
  </svg>
);
export default NewsDetail;
